import React, {Component} from 'react';
import {Button, Col, Empty, Result, Row} from "antd";
import AllScansCaseView from './scansCase';
import {markCaseRead} from '../redux_actions/cases.action'
import {connect} from "react-redux";
import AllScansCliaCaseView from './caseClia';
import cookie from "react-cookies";

class SingleCaseView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            caseMode: 'viewMode',
            selectedCaseId: this.props.match.params.id,
            showTabs: false,
            showClia: false,
        }
    }

    showClia = () => {
        if (window.location.href.includes("clia_case")) {
            this.setState({showClia: true})
        }
    }

    componentWillMount = () => {
        this.props.dispatch(markCaseRead({id: this.props.match.params.id}, false));
        this.showClia();
    }

    isValidUUID = (uuid) => {
        let token = "" + uuid
        token = token.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
        if (token === null) {
            return false;
        }
        return true;
    }

    getCaseView = () => {
        if (this.state.showClia === true) {
            if (this.isValidUUID(cookie.loadAll().screen_supported) || cookie.loadAll().clia_screen_check === "false") {
                return (
                    <div>
                        <AllScansCliaCaseView case={this.state.selectedCaseId} setTabsView={this.changeTabsView}/>
                    </div>
                )
            } else {
                return (
                    <div>
                        <Result
                            title="Your Screen Isnt Supported"
                            extra={
                                <Button type="primary" key="console" onClick={this.openDashboard}>
                                    Go To Dashboard
                                </Button>
                            }
                        />
                    </div>
                )
            }

        } else if (this.state.caseMode === 'viewMode') {
            return (
                <div>
                    <AllScansCaseView case={this.state.selectedCaseId} setTabsView={this.changeTabsView} />
                </div>

            );
        }
    }

    changeTabsView = (value) => {
        this.setState({
            showTabs: value,
        });
    }

    render() {
        return (
            <div>
                <Row>
                    <Col span={24} offset={0} className="all-slides">
                        {this.state.selectedCaseId ?
                            <div>
                                <Row>
                                    {this.getCaseView()}
                                </Row>
                            </div>
                            :
                            <Empty description="No Case to Display"/>
                        }
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        allCases: state.casesReducer,
        allCaseStatus: state.caseStatusReducer.case_status,
        allUsers: state.caseStatusReducer.users,
        numPages: state.caseStatusReducer.numPages,
        pageNumber: state.caseStatusReducer.pageNumber,
        urlState: state.searchCaseReducer,
        isFetching: state.searchCaseReducer.isFetching
    };
};

export default connect(mapStateToProps)(SingleCaseView);